<template>
  <narrow-container>
    <h1 class="headline-secondary text--center">
      {{ $i18n.t('TOPUP_MPAY_ERROR.HEADER') }}
    </h1>
    <br>
    <p class="text--center">
      {{ $i18n.t('TOPUP_MPAY_ERROR.TEXT') }}
    </p>
    <br>
    <div class="block--centered">
      <router-link
        class="button button--blue button--centered"
        :to="{name:'manage'}"
      >
        {{ $i18n.t('COMMON.OK') }}
      </router-link>
    </div>
  </narrow-container>
</template>

<script>
  export default {
    name: "TopupMpayError",
    components: {},
    mounted: function () {
      this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Topup mPay',label: 'Error mPay', value: 0, noninteraction: false });
      this.$store.commit("clearLastTopupValue");
    }

  }
</script>

<style scoped lang="scss">
  .button--centered {
    padding-right: 62px;
    padding-left: 62px;
  }
  .block--centered {
    text-align: center;
  }
</style>
